import { cva, type VariantProps } from 'class-variance-authority';

/**
 * ExpertQuote card variant styles using Class Variance Authority (CVA).
 * All styles use design tokens from the HEN Design System.
 *
 * Card: white background, 10px rounded corners (rounded-md), subtle border (neutral-200) and subtle shadow.
 */

export const expertQuoteVariants = cva('w-full text-left', {
  variants: {
    variant: {
      card: ['bg-white', 'rounded-lg', 'px-xl', 'py-lg'],
      plain: ['bg-transparent', 'rounded-none', 'p-0', 'shadow-none'],
    },
  },
  defaultVariants: {
    variant: 'card',
  },
});

export type ExpertQuoteVariantProps = VariantProps<typeof expertQuoteVariants>;
